import { render } from "./TwoFaAuthenticatorPage.vue?vue&type=template&id=0279751d&ts=true"
import script from "./TwoFaAuthenticatorPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TwoFaAuthenticatorPage.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/authentication/TwoFaAuthenticatorPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0279751d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0279751d', __exports__)) {
    api.reload('0279751d', __exports__)
  }
  
  module.hot.accept("./TwoFaAuthenticatorPage.vue?vue&type=template&id=0279751d&ts=true", () => {
    api.rerender('0279751d', render)
  })

}


export default __exports__